var _circle, _circle2, _circle3, _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgRecipes16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.00003,
    cy: 5.168,
    r: 4.61539,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.38461,
    cy: 6.3989,
    r: 3.38461,
    fill: "currentColor"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.6152,
    cy: 6.3989,
    r: 3.38461,
    fill: "currentColor"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.86597,
    cy: 16.4688,
    rx: 3.93311,
    ry: 0.615385,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.86629 11.1662C8.78974 11.1662 9.64986 10.895 10.3713 10.4279C10.7805 10.7546 11.267 10.9884 11.7991 11.0973V15.2571C10.7872 15.0435 9.39854 14.9118 7.86625 14.9118C6.33368 14.9118 4.94476 15.0436 3.93286 15.2572V11.0974C4.46517 10.9885 4.95196 10.7547 5.36125 10.4279C6.08272 10.895 6.94283 11.1662 7.86629 11.1662Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRecipes16);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;